import React from "react";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";
import { Button } from "@mui/material";
import { NavLink } from "react-router-dom";

function NotFound(props) {
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <h2 className="heading" style={{ margin: 0 }}>
            Page Not Found
          </h2>
          <SearchOffOutlinedIcon style={{ marginLeft: 10, fontSize: 30 }} />
        </div>
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <NavLink to="/" style={{textDecoration: 'none'}}>
            <Button variant="contained" style={{ fontFamily: "inherit", backgroundColor: 'var(--theme-orange)' }}>
              Back home
            </Button>
          </NavLink>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
